import * as yup from 'yup';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import { useContactDetailsFormDefinition } from '@gov-nx/core/hooks';
import { useLocale } from '@gov-nx/core/service';
import type { ServiceCode } from '@gov-nx/module/service';
import type { FormDataStep2b } from './context.types';
import type { IFormStep2b } from './form.types';

interface FormStep2Props {
	code: ServiceCode;
	isProcessing: boolean;
}

export const FormStep2b = ({
	code,
	isProcessing,
}: FormStep2Props): IFormStep2b => {
	const { t } = useLocale(code);
	const { shape, defaultValues, fields } = useContactDetailsFormDefinition();

	const formSchema = yup.object(shape).required();

	const formMethods = useGovForm<FormDataStep2b>({
		formSchema,
		defaultValues,
	});

	return {
		fields: fields(isProcessing, {
			email: {
				label: t('formular.pole.kontakt-email'),
				placeholder: t('formular.placeholder.email'),
			},
			phone: {
				label: t('formular.pole.kontakt-telefon'),
				placeholder: t('formular.placeholder.telefon'),
			},
		}),
		formDefinition: getFormDefinition({ formMethods, formSchema }),
	};
};
